export default __webpack_public_path__ + "static/media/home.1bd0eb61.svg";